import _omitBy from 'lodash/omitBy';
import isValueEmpty from './isValueEmpty';

const filterEmptyParams = (params: Record<string, object | string | number | boolean>) => {
  return _omitBy(params, value => isValueEmpty(value));
};

export default filterEmptyParams;
